module.exports = __webpack_public_path__ + "static/media/Gasplant.60bdfbee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Gasplant.svg
// module id = 189
// module chunks = 0